import * as React from 'react';

var _path, _path2;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.468 7.126l4.568 4.567-.707.707-3.361-3.36v11.077h-1V9.04L13.609 12.4l-.707-.707 4.566-4.567zm-7.775 6.89l-.5.5v11.623l.5.5h15.555l.5-.5V14.515l-.5-.5h-5.629v1h5.129V25.64H10.193V15.015h5.34v-1h-5.84z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.477 1.5c-8.56 0-15.5 6.94-15.5 15.5 0 8.56 6.94 15.5 15.5 15.5 8.561 0 15.5-6.94 15.5-15.5 0-8.56-6.939-15.5-15.5-15.5zM.977 17C.978 7.887 8.366.5 17.478.5c9.113 0 16.5 7.387 16.5 16.5s-7.387 16.5-16.5 16.5C8.365 33.5.977 26.113.977 17z"
  })));
}

export { SvgUpload as default };